import React from 'react';
import './styles.css';

const Chip = ({ children }) => {
  return <div className="cb-chip">{children}</div>;
};

export default Chip;
